require('select2');

(() => {
    $(document).ready(() => {
        const elem = $('#search_search');

        if (elem.length) {
            const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
    
            alphabet.forEach(letter => {
                const optionElement = new Option(letter.toUpperCase(), letter)
                optionElement.classList.add('search-terms__search__letter')
                elem.prepend(optionElement)
            })
    
            let options = [...elem[0].options]
            options.sort((a, b) => a.innerHTML.charCodeAt(0) - b.innerHTML.charCodeAt(0))
            
            elem.html('').append(options)
    
            if (elem.length > 0 && typeof redirectURl != 'undefined') {
                elem.select2({
                    width: '100%',
                    placeholder: 'Zadejte hledaný výraz',
                    language: {
                        "noResults": () =>  {
                          return "Nic jsme nenašli."
                        }
                    },
                });
                elem.change((e) => {
                    const url = e.target.value.length === 1 
                        ? redirectURl.replace('/termName', "?p=" + e.target.value) 
                        : redirectURl.replace('termName', elem.select2('val'));
                    
                    location.href = url;
                    elem.val(null);
                });
            }
        }
    })
})();



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/searchTerms.js